import { HasuraAuthClient as g } from "@nhost/hasura-auth-js";
export * from "@nhost/hasura-auth-js";
import { HasuraStorageClient as k } from "@nhost/hasura-storage-js";
export * from "@nhost/hasura-storage-js";
import p from "axios";
import { print as w } from "graphql";
const T = /^((?<protocol>http[s]?):\/\/)?(?<host>localhost)(:(?<port>(\d+|__\w+__)))?$/;
function f(r, e) {
  const { backendUrl: s, subdomain: t, region: o } = r;
  if (s)
    return `${s}/v1/${e}`;
  if (!t)
    throw new Error("Either `backendUrl` or `subdomain` must be set.");
  const c = t.match(T);
  if (c != null && c.groups) {
    const { protocol: n = "http", host: a, port: i = 1337 } = c.groups, u = A(e);
    return u || `${n}://${a}:${i}/v1/${e}`;
  }
  if (!o)
    throw new Error('`region` must be set when using a `subdomain` other than "localhost".');
  return `https://${t}.${e}.${o}.nhost.run/v1`;
}
function U() {
  return typeof window < "u";
}
function b() {
  return typeof process < "u" && process.env;
}
function A(r) {
  return U() || !b() ? null : process.env[`NHOST_${r.toUpperCase()}_URL`];
}
function E(r) {
  const e = "subdomain" in r || "backendUrl" in r ? f(r, "auth") : r.authUrl;
  if (!e)
    throw new Error("Please provide `subdomain` or `authUrl`.");
  return new g({ url: e, ...r });
}
function v(r) {
  const e = "subdomain" in r || "backendUrl" in r ? f(r, "functions") : r.functionsUrl;
  if (!e)
    throw new Error("Please provide `subdomain` or `functionsUrl`.");
  return new S({ url: e, ...r });
}
class S {
  constructor(e) {
    const { url: s, adminSecret: t } = e;
    this.url = s, this.accessToken = null, this.adminSecret = t, this.instance = p.create({
      baseURL: s
    });
  }
  async call(e, s, {
    useAxios: t = !0,
    ...o
  } = {}) {
    t && console.warn(
      "nhost.functions.call() will no longer use Axios in the near future. Please add `useAxios: false` in the config argument to use the new implementation."
    );
    const c = {
      ...this.generateAccessTokenHeaders(),
      ...o == null ? void 0 : o.headers
    };
    let n;
    try {
      n = await this.instance.post(e, s, { ...o, headers: c });
    } catch (a) {
      if (a instanceof Error) {
        if (t)
          return { res: null, error: a };
        const i = a;
        return {
          res: null,
          error: {
            error: i.code || "unknown",
            status: i.status || 0,
            message: i.message
          }
        };
      }
    }
    return n ? t ? { res: n, error: null } : {
      res: {
        status: n.status,
        statusText: n.statusText,
        data: n.data
      },
      error: null
    } : t ? {
      res: null,
      error: new Error("Unable to make post request to function")
    } : {
      res: null,
      error: {
        error: "invalid-response",
        status: 0,
        message: "Unable to make post request to function"
      }
    };
  }
  setAccessToken(e) {
    if (!e) {
      this.accessToken = null;
      return;
    }
    this.accessToken = e;
  }
  generateAccessTokenHeaders() {
    return this.adminSecret ? {
      "x-hasura-admin-secret": this.adminSecret
    } : this.accessToken ? {
      Authorization: `Bearer ${this.accessToken}`
    } : {};
  }
}
function q(r) {
  const e = "subdomain" in r || "backendUrl" in r ? f(r, "graphql") : r.graphqlUrl;
  if (!e)
    throw new Error("Please provide `subdomain` or `graphqlUrl`.");
  return new C({ url: e, ...r });
}
class C {
  constructor(e) {
    const { url: s, adminSecret: t } = e;
    this.url = s, this.accessToken = null, this.adminSecret = t, this.instance = p.create({
      baseURL: s
    });
  }
  async request(e, s, {
    useAxios: t = !0,
    ...o
  } = {}) {
    const c = {
      "Accept-Encoding": "*",
      ...this.generateAccessTokenHeaders(),
      ...o == null ? void 0 : o.headers
    };
    try {
      const n = "", i = (await this.instance.post(
        "",
        {
          operationName: n || void 0,
          query: typeof e == "string" ? e : w(e),
          variables: s
        },
        { ...o, headers: c }
      )).data, { data: u } = i;
      return i.errors ? {
        data: null,
        error: i.errors
      } : typeof u != "object" || Array.isArray(u) || u === null ? t ? {
        data: null,
        error: new Error("incorrect response data from GraphQL server")
      } : {
        data: null,
        error: {
          error: "invalid-response",
          status: 0,
          message: "incorrect response data from GraphQL server"
        }
      } : { data: u, error: null };
    } catch (n) {
      if (console.error(n), t)
        return n instanceof Error ? { data: null, error: n } : {
          data: null,
          error: new Error("Unable to get do GraphQL request")
        };
      const a = n;
      return {
        data: null,
        error: {
          error: a.code || "unknown",
          status: a.status || 0,
          message: a.message
        }
      };
    }
  }
  getUrl() {
    return this.url;
  }
  setAccessToken(e) {
    if (!e) {
      this.accessToken = null;
      return;
    }
    this.accessToken = e;
  }
  generateAccessTokenHeaders() {
    return this.adminSecret ? {
      "x-hasura-admin-secret": this.adminSecret
    } : this.accessToken ? {
      Authorization: `Bearer ${this.accessToken}`
    } : {};
  }
}
function $(r) {
  const e = "subdomain" in r || "backendUrl" in r ? f(r, "storage") : r.storageUrl;
  if (!e)
    throw new Error("Please provide `subdomain` or `storageUrl`.");
  return new k({ url: e, ...r });
}
const G = (r) => new y(r);
class y {
  constructor({
    refreshIntervalTime: e,
    clientStorageGetter: s,
    clientStorageSetter: t,
    clientStorage: o,
    clientStorageType: c,
    autoRefreshToken: n,
    autoSignIn: a,
    adminSecret: i,
    devTools: u,
    start: m = !0,
    ...h
  }) {
    this.auth = E({
      refreshIntervalTime: e,
      clientStorageGetter: s,
      clientStorageSetter: t,
      clientStorage: o,
      clientStorageType: c,
      autoRefreshToken: n,
      autoSignIn: a,
      start: m,
      ...h
    }), this.storage = $({ adminSecret: i, ...h }), this.functions = v({ adminSecret: i, ...h }), this.graphql = q({ adminSecret: i, ...h }), this.auth.onAuthStateChanged((l, d) => {
      l === "SIGNED_OUT" && (this.storage.setAccessToken(void 0), this.functions.setAccessToken(void 0), this.graphql.setAccessToken(void 0));
    }), this.auth.onTokenChanged((l) => {
      const d = l == null ? void 0 : l.accessToken;
      this.storage.setAccessToken(d), this.functions.setAccessToken(d), this.graphql.setAccessToken(d);
    }), this._adminSecret = i, this.devTools = u;
  }
  get adminSecret() {
    return this._adminSecret;
  }
  set adminSecret(e) {
    this._adminSecret = e, this.storage.setAdminSecret(e);
  }
}
export {
  y as NhostClient,
  S as NhostFunctionsClient,
  C as NhostGraphqlClient,
  E as createAuthClient,
  v as createFunctionsClient,
  q as createGraphqlClient,
  G as createNhostClient,
  $ as createStorageClient
};
//# sourceMappingURL=index.esm.js.map
